import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/pos_change';

/** 状況 `pos_change_turn`（組み立ては `../fx/pos_change.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'pos_change_turn', role: 'effect', ...spec }, 'pos_change_turn_effect.js');
